export default __webpack_public_path__ + "static/media/sem-foto.e64a32a4.png";